import React from 'react'
import { StyledText } from './StyledText'

// default body text
export const P = ({ children, ...props }) => (
  <StyledText {...props}>{children}</StyledText>
)
